import { useProfileImageUrl } from '../hooks/useProfileImageUrl';

type Props = {
  attachmentId?: string | null;
  email?: string;
  className?: string;
};

export function UserAvatar({ attachmentId, email, className = 'h-8 w-8' }: Props) {
  const imageUrl = useProfileImageUrl(attachmentId);
  const initial = email?.charAt(0).toUpperCase() || 'U';

  if (imageUrl) {
    return (
      <img
        src={imageUrl}
        alt=""
        className={`${className} rounded-full object-cover shadow-sm`}
      />
    );
  }

  return (
    <div
      className={`${className} flex items-center justify-center rounded-full bg-primary text-sm font-medium text-primary-foreground shadow-sm`}
    >
      {initial}
    </div>
  );
}
